import script from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClubServiceCard.vue?vue&type=script&setup=true&lang=ts"

import "./ClubServiceCard.vue?vue&type=style&index=0&id=e3cce530&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3cce530"]])

export default __exports__